import { render } from "./ProgressDialog.vue?vue&type=template&id=78b6743c&bindings={\"message\":\"props\",\"isLoading\":\"props\",\"size\":\"props\",\"strokeWidth\":\"props\",\"animationDuration\":\"props\",\"fill\":\"props\",\"hasMessage\":\"options\"}"
import script from "./ProgressDialog.vue?vue&type=script&lang=js"
export * from "./ProgressDialog.vue?vue&type=script&lang=js"

import "./ProgressDialog.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script